import Vue from 'vue';
import { mapGetters } from 'vuex';
// For microsoftTeams docs see:
// https://learn.microsoft.com/en-us/javascript/api/@microsoft/teams-js
import * as microsoftTeams from "@microsoft/teams-js";
import BotAPI from 'src/api/chatbots';
import _ from 'lodash';
import microsoftIcon from 'assets/img/microsoft-teams.svg';
import kapicheIcon from 'assets/favicon.svg';
import { formatDateTime } from 'src/utils/formatters';
const ConfigureTeamsConnector = Vue.extend({
    data() {
        return {
            microsoftIcon,
            kapicheIcon,
            loading: true,
            hooks: undefined,
            appContext: undefined,
            selectedSite: undefined,
        };
    },
    computed: {
        ...mapGetters([
            'availableSites',
        ]),
        // When this page is loaded in the teams connection configuration page,
        // it gets loaded as an iframe. This page shouldn't be used outside MS
        // Teams but for local development and testing, we'll allow it but
        // disable the calls to the teams sdk.
        inTeams() {
            return (top !== self);
        },
        sites() {
            return (this.availableSites ?? []).filter((s) => s.user_type === 'ADMIN');
        },
    },
    watch: {
        sites(newVal, oldVal) {
            if (_.isEqual(oldVal, newVal))
                return;
            if (newVal.length === 1) {
                this.selectedSite = newVal[0].domain;
            }
            this.getWebhooks(newVal);
        },
        selectedSite(val) {
            if (val !== undefined && this.inTeams) {
                this.enableSave();
            }
        }
    },
    async mounted() {
        if (this.inTeams) {
            await microsoftTeams.app.initialize();
            microsoftTeams.pages.config.setValidityState(false);
            await microsoftTeams.pages.getConfig();
            this.appContext = await microsoftTeams.app.getContext();
            microsoftTeams.pages.config.registerOnSaveHandler(this.onSaveHandler);
            microsoftTeams.pages.config.registerOnRemoveHandler(this.onRemoveHandler);
        }
        if (this.sites.length === 1) {
            this.selectedSite = this.sites[0].domain;
        }
        this.getWebhooks(this.sites);
    },
    methods: {
        formatDateTime,
        contextToDisplayName(appContext) {
            return `${appContext?.team?.displayName} - ${appContext?.channel?.displayName}`;
        },
        enableSave() {
            microsoftTeams.pages.config.setValidityState(true);
        },
        async getWebhooks(sites) {
            this.loading = true;
            try {
                const responses = await Promise.all((sites).map((s) => BotAPI.listWebhooks('teams', s.domain)));
                this.hooks = responses.flat();
            }
            finally {
                this.loading = false;
            }
        },
        async onSaveHandler(saveEvent) {
            const pageConfig = await microsoftTeams.pages.getConfig();
            const appContext = await microsoftTeams.app.getContext();
            const webhookUrl = pageConfig.webhookUrl;
            if (!webhookUrl) {
                saveEvent.notifyFailure();
                return;
            }
            try {
                const response = await BotAPI.addWebhook('teams', webhookUrl, appContext.channel, appContext.team, this.selectedSite);
                await microsoftTeams.pages.config.setConfig({
                    contentUrl: window.location.origin + "/configure-teams-connector",
                    removeUrl: window.location.origin + "/configure-teams-connector",
                    entityId: JSON.stringify({ id: response.id, site: this.selectedSite }),
                });
                saveEvent.notifySuccess();
            }
            catch (e) {
                saveEvent.notifyFailure(e?.toString());
            }
        },
        async onRemoveHandler(removeEvent) {
            microsoftTeams.pages.config.setValidityState(false);
            try {
                const pageConfig = await microsoftTeams.pages.getConfig();
                const config = JSON.parse(pageConfig.entityId ?? '');
                await BotAPI.removeWebhook(config.id, config.site);
            }
            catch (e) {
                removeEvent.notifyFailure(e?.toString());
            }
        },
    }
});
export default ConfigureTeamsConnector;
